var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgInformationIconRed = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "63px",
    viewBox: "0 0 90 63",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Information_Icon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u05D4\\u05E2\\u05D1\\u05E8\\u05D5\\u05EA",
    stroke: "none",
    strokeWidth: 1,
    fill: "rgba(255, 129, 3,0.1)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4_Kavei_Extra_services_BlueBird_Priority_Pass_popup2",
    transform: "translate(-1220.000000, -592.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Information_Icon",
    transform: "translate(1220.000000, 592.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.1204293,4.23327053 L8.09716031,0.0105900541 C3.21090986,-0.243238073 -0.667696898,4.10370136 0.0964609846,8.97741382 L5.6907604,51.5195272 C6.34497054,55.6922917 10.1860855,58.5714885 14.3362969,58.0011718 L53.0230535,52.6814015 C54.3529578,52.4987303 55.6987645,52.8577006 56.7659106,53.6786593 C60.0779284,56.226499 64.4791029,59.56025 67.5930252,61.9126739 C69.1759989,63.1085336 71.4303489,61.966838 71.4303489,59.9723224 L71.4303489,52.0378039 C71.4303489,50.963017 72.2180971,50.0539087 73.2743958,49.9094709 L80.6179362,48.6891843 C83.9606004,48.1337361 86.55027,45.4403966 86.9978542,42.0535435 L89.5403665,12.014855 C90.0616705,8.02900998 87.102349,4.44143084 83.1204293,4.23327053 Z",
    id: "Fill-15",
    fill: "rgba(255, 129, 3,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2869856,7.13124807 L11.1392373,3.40933418 C6.83104776,3.18560747 3.41129403,7.01704447 4.08504931,11.3127846 L9.01752312,48.8098397 C9.59433786,52.4877571 12.9810352,55.0255107 16.6402618,54.5228277 L50.7502369,49.8339276 C51.9228088,49.6729193 53.1094018,49.9893194 54.0503006,50.7129209 C56.9704949,52.9586129 60.8509947,55.8970152 63.5965289,57.9704657 C64.9922312,59.0245088 66.9798835,58.0182066 66.9798835,56.2602201 L66.9798835,49.266654 C66.9798835,48.3193259 67.6744383,47.5180285 68.6057731,47.3907196 L75.0805465,46.3151464 C78.0277615,45.8255687 80.3110639,43.4516316 80.7056973,40.4664246 L82.9474214,13.9900164 C83.4070532,10.4768517 80.79783,7.31472269 77.2869856,7.13124807 Z",
    id: "Fill-15",
    opacity: 0.464117006
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInformationIconRed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/information-icon-red.d080015e.svg";
export { ForwardRef as ReactComponent };